module.exports = __webpack_public_path__ + "static/14-a5bf1ad9a2fa88db4ac9ce064e3bb4b4.jpg";